const UserReport = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='16' fill='#FFF3BF' />
      <g clipPath='url(#clip0_3394_52614)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.9999 12C19.9999 14.2091 18.2091 16 15.9999 16C13.7908 16 11.9999 14.2091 11.9999 12C11.9999 9.79086 13.7908 8 15.9999 8C18.2091 8 19.9999 9.79086 19.9999 12ZM8.36621 23.3143C9.38565 20.0686 12.4179 17.7143 16 17.7143C19.582 17.7143 22.6142 20.0686 23.6337 23.3143C23.743 23.6622 23.4709 24 23.1062 24H8.89371C8.52901 24 8.25693 23.6622 8.36621 23.3143Z'
          fill='#FA5252'
        />
      </g>
      <defs>
        <clipPath id='clip0_3394_52614'>
          <rect width='16' height='16' fill='white' transform='translate(8 8)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserReport;
